/* vp-faq — one-question-open-at-a-time accordion.
   Native <details> rows keep content in the DOM (SEO/AEO). JS only enforces
   the single-open behavior and is safe across multiple section instances. */
(function () {
  'use strict';

  function initList(list) {
    if (!list || list.dataset.vpFaqInit === 'true') return;
    list.dataset.vpFaqInit = 'true';

    var items = Array.prototype.slice.call(
      list.querySelectorAll('.js-vp-faq-item')
    );

    items.forEach(function (item) {
      item.addEventListener('toggle', function (event) {
        if (!event.target.open) return;
        items.forEach(function (other) {
          if (other !== event.target && other.open) {
            other.open = false;
          }
        });
      });
    });
  }

  function initWithin(root) {
    (root || document)
      .querySelectorAll('.js-vp-faq-list')
      .forEach(initList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWithin(document);
    });
  } else {
    initWithin(document);
  }

  /* Re-init when the theme editor injects/reloads a section. */
  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });
})();
